import React, { useEffect, useState } from "react";
import styles from "../../../styles/scope1/dashboard.module.css";
import { durationObj, monthSort } from "../../../utils/constant";
import LineChart from "../../../Components/GraphNCharts/LineChart";
import PieChart from "../../../Components/GraphNCharts/Pie";
import { Box, Typography } from "@mui/material";
import BarChart from "../../../Components/GraphNCharts/BarChart";
import GlobalChart from "../../../Components/GraphNCharts/GlobalChart";
import TableChart from "../../../Components/GraphNCharts/TableChart";
import EchartDoughnutChart from "../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../utils/api";
import CircleIcon from "@mui/icons-material/Circle";
import PeriodFilter from "../../../Components/Common/PeriodFilter";
import { fixedTons, formatNumberCommaSeparated } from "../../../utils/common";
import useAuthStore from "../../../store/ContextUser";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import Scope4Layout from "../../../Layout/Scope4Layout";
import Cards from "../../../Components/Common/Cards";
import { Bar } from "react-chartjs-2";
const Dashboard = () => {
  const currentDate = new Date();
  const { selectedCompany } = useAuthStore();
  const currentYear = currentDate.getFullYear();
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const [ghg, setGhg] = useState([]);
  const [emissionVehicleType, setEmissionVehicleType] = useState([]);
  const [stationaryEmission, setStationaryEmission] = useState([]);
  const [mobileEmissionTotal, setMobileEmissionTotal] = useState([]);
  const [mobileEmission, setMobileEmission] = useState([]);
  const [vehicleEmission, setVehicleEmission] = useState([]);
  const [fugitive, setFugitive] = useState([]);
  const [carbonProduct, setCarbonProduct] = useState([]);
  const [stationaryCombustion, setStationaryCombustion] = useState({});
  const [mobileCombustion, setMobileCombustion] = useState({});
  const [fugitiveCombustion, setFugitiveCombustion] = useState({});
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [selectedFacility, setSelectedFacility] = useState([]);

  useEffect(() => {
    fetchStationaryEmission();
    fetchMobileEmissionTotal();
    fetchMobileEmission();
    fetchEmissionByVehicle();
    fetchVehicleEmission();
    fetchFugitiveEmission();
    fetchStationary();
    fetchMobile();
    fetchFugitive();
    fetchGHGEmission();
  }, [fromDate, toDate, selectedFacility, selectedCompany]);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/scope1/totalEmission?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month, selectedCompany]);

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1).padStart(2, "0"));
  //   setYear(currentDate.getFullYear());
  // }, []);

  const fetchGHGEmission = async () => {
    const res = await get(
      `/dashboard/scope1/emissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    console.log(
      res?.data?.finalData
        ?.map((el) => el?.data?.map((el) => el?.totalEmission)?.filter(Boolean))
        ?.filter((res) => res?.length > 0),
      "check"
    );

    setGhg([
      {
        total: res?.data?.total?.toFixed(3),
        labels: res?.data?.finalData?.[0]?.data?.map(
          (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
        ),
        dataSet:
          res?.data?.finalData
            ?.map((el) =>
              el?.data?.map((el) => el?.totalEmission)?.filter(Boolean)
            )
            ?.filter((res) => res?.length > 0)?.length > 0
            ? res?.data?.finalData?.map((el, i) => ({
                label: el?.label,
                data: el?.data?.map((el) => fixedTons(el?.totalEmission)) || 0,
                borderColor: colors[i],
                backgroundColor: colors[i],
                tension: 0.4,
                fill: true,
                pointRadius: 0,
              }))
            : [],
      },
    ]);
  };

  const fetchStationaryEmission = async () => {
    const res = await get(
      `/dashboard/scope1/statinaryEmissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setStationaryEmission(res?.data);
  };

  const fetchMobileEmissionTotal = async () => {
    const res = await get(
      `/dashboard/scope1/mobileEmissionAnalysisTotal?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setMobileEmissionTotal(res?.data);
  };

  const fetchMobileEmission = async () => {
    const res = await get(
      `/dashboard/scope1/mobileEmissionAnalysisOffRoad?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setMobileEmission(res?.data);
  };

  const fetchEmissionByVehicle = async () => {
    const res = await get(
      `/dashboard/scope1/onRoadEmissionByTransportType?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setEmissionVehicleType([
      {
        labels: res?.data?.data?.map((el) => el?.transportType),
        dataSet: [
          {
            label: "GHG Emissions (tCO2e)",
            data: res?.data?.data?.map((el) => el?.totalEmission),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
    ]);
  };

  const fetchVehicleEmission = async () => {
    const res = await get(
      `/dashboard/scope1/onRoadEmissionByVehicle?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setVehicleEmission([
      {
        color: "#FF4444",
        label: "Company Owned",
        value:
          res?.data?.data
            ?.find((el) => el?.ownershipType === "Company Owned")
            ?.totalEmissionsByOwnership?.toFixed(3) || 0,
      },
      {
        color: "#0066E7",
        label: "Third Party Vehicles",
        value:
          res?.data?.data
            ?.find((el) => el?.ownershipType === "Leased")
            ?.totalEmissionsByOwnership?.toFixed(3) || 0,
      },
    ]);
  };

  const fetchFugitiveEmission = async () => {
    const res = await get(
      `/dashboard/scope1/fugitiveEmissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setFugitive([
      {
        value: parseFloat(res?.data?.refrigerationSum) || 0,
        title: "Total energy exported YTD (kWh):",
        labels: res?.data?.refrigeration?.map((el) => el?.typeOfSubstance),
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.refrigeration?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
      {
        value: parseFloat(res?.data?.fireSum) || 0,
        labels: res?.data?.fireExtinguisher?.map((el) => el?.typeOfSubstance),
        title: "Avoided emissions from export (tCO₂e) :",
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.fireExtinguisher?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },

      {
        value: parseFloat(res?.data?.refrigerationSum) || 0,
        title: "Effective grid emission factor used:",
        labels: res?.data?.refrigeration?.map((el) => el?.typeOfSubstance),
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.refrigeration?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
      {
        value: parseFloat(res?.data?.fireSum) || 0,
        labels: res?.data?.fireExtinguisher?.map((el) => el?.typeOfSubstance),
        title: "Emissions by Facility :",
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.fireExtinguisher?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
    ]);
  };

  const fetchStationary = async () => {
    const res = await get(
      `/dashboard/scope1/stationaryCombusionEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setStationaryCombustion({
      labels: res?.data?.data?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.data?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const fetchMobile = async () => {
    const res = await get(
      `/dashboard/scope1/mobileCombusionEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setMobileCombustion({
      labels: res?.data?.data?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.data?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const fetchFugitive = async () => {
    const res = await get(
      `/dashboard/scope1/fugitiveEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${
        selectedCompany?._id
      }`
    );
    setFugitiveCombustion({
      labels: res?.data?.finalData?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.finalData?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  // Stationary Emission
  let stationaryEmissionLabels = [
    stationaryEmission?.naturalGasData?.length > 0
      ? {
          color: "#FFBB33",
          label: "Natural Gas",
          value:
            stationaryEmission?.naturalGasData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.coalData?.length > 0
      ? {
          color: "#000000",
          label: "Coal",
          value: stationaryEmission?.coalData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.petrolData?.length > 0
      ? {
          color: "#0066E7",
          label: "Petrol",
          value: stationaryEmission?.petrolData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.dieselData?.length > 0
      ? {
          color: "#FF4444",
          label: "Diesel",
          value: stationaryEmission?.dieselData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.fuelData?.length > 0
      ? {
          color: "#28C76F",
          label: "Fuel Oil",
          value: stationaryEmission?.fuelData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.lpgData?.length > 0
      ? {
          color: "#a16ae8",
          label: "LPG",
          value: stationaryEmission?.lpgData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.propaneData?.length > 0
      ? {
          color: "#ff6b9d",
          label: "Propane",
          value: stationaryEmission?.propaneData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
  ].filter(Boolean);

  // vehicle emission

  const colors = [
    "rgba(255, 68, 68, 1)",
    "rgba(255, 187, 51, 1)",
    "rgba(0, 102, 231, 1)",
  ];

  let bannerData = [
    {
      title: "Total avoided emissions (tCO₂e)",
      description: 28,
    },
    {
      title: "Top avoidance source ",
      description: 28,
    },
    {
      title: "Avoidance intensity",
      description: 28,
    },
    {
      title: "% Change in Avoidance",
      description: 28,
    },
  ];

  let bannerData1 = [
    {
      title: "Product with highest contribution to avoidance",
      description: "Lorem ipsum",
    },
  ];

  let bannerData2 = [
    {
      title: "Total Carbon Sequestered",
      description: "Lorem ipsum",
    },
    {
      title: "% of Annual Emissions Offset",
      description: "Lorem ipsum",
    },
    {
      title: "Project with Highest Sequestration",
      description: "Lorem ipsum",
    },
  ];

  const data = {
    labels: ["Verified", "Lorem Ipsum"],
    datasets: [
      {
        label: "%",
        data: [70, 50], // sample values
        backgroundColor: ["#007bff", "#f57c00"], // blue and orange
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Verified vs Unverified Credits",
        align: "start",
        font: {
          size: 14,
        },
        color: "#555",
        padding: {
          bottom: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 20,
          callback: (value) => `${value} %`,
        },
        title: {
          display: true,
          text: "%",
          color: "#555",
          font: {
            size: 12,
          },
        },
        grid: {
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };


  const data1 = {
    labels: ["lorem", "lorem", "lorem", "lorem", "lorem", "lorem", "lorem"],
    datasets: [
      {
        label: "Distribution",
        data: [2000000, 2000000, 2000000, 2000000, 2000000, 2000000, 2000000],
        backgroundColor: "#FF4D4D",
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };

  const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            if (value >= 1000000) return `${value / 1000000}M`;
            if (value >= 1000) return `${value / 1000}k`;
            return value;
          },
        },
        grid: { drawBorder: false },
      },
      x: {
        grid: { display: false },
      },
    },
  };


  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Offsetting">
        <div>
          <div className={styles.heading_container}>
            <p className={styles.heading}>Scope 4</p>
            <PeriodFilter
              {...{
                fromDate,
                setFromDate,
                toDate,
                setToDate,
                yearList,
                setSelectedFacility,
                selectedFacility,
              }}
            />
          </div>

          <Cards
            data={bannerData}
            title={"Overview"}
            // onFilterChange={handlePeriodChange}
            // {...{
            //   setSelectedMonth,
            //   setSelectedYear,
            //   selectedMonth,
            //   selectedYear,
            // }}
          />

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline" }}
          >
            1. Avoidance from Renewable Energy Export
          </p>
          <div className={styles.mobile_container}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "24px", // spacing between charts
              }}
            >
              {fugitive?.map((el, index) => (
                <div key={index} className={styles.diversity_container}>
                  <p className={styles.emission_heading}>
                    {el?.title}
                    <span className={styles.emission_heading_span}>
                      {formatNumberCommaSeparated(fixedTons(el?.value ?? 0))}
                    </span>
                  </p>
                  <BarChart
                    datasets={el?.dataSet}
                    labels={el?.labels}
                    yAxisTitle={"Quantity"}
                    customWidth={420}
                    customHeight={"375px"}
                    ellipsis={true}
                  />
                </div>
              ))}
            </div>
          </div>

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline" }}
          >
            2. Low-Carbon Product Use
          </p>
          <Cards
            data={bannerData1}
            title={"Overview"}
            // onFilterChange={handlePeriodChange}
            // {...{
            //   setSelectedMonth,
            //   setSelectedYear,
            //   selectedMonth,
            //   selectedYear,
            // }}
          />
          <div
            className={styles.mobile_container}
            style={{ marginTop: "1rem" }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "24px", // spacing between charts
              }}
            >
              {fugitive?.map((el, index) => (
                <div key={index} className={styles.diversity_container}>
                  <p className={styles.emission_heading}>
                    {el?.title}
                    <span className={styles.emission_heading_span}>
                      {formatNumberCommaSeparated(fixedTons(el?.value ?? 0))}
                    </span>
                  </p>
                  <BarChart
                    datasets={el?.dataSet}
                    labels={el?.labels}
                    yAxisTitle={"Quantity"}
                    customWidth={420}
                    customHeight={"375px"}
                    ellipsis={true}
                  />
                </div>
              ))}
            </div>
          </div>

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline" }}
          >
            3. Carbon Offsetting:
          </p>
          <Cards
            data={bannerData2}
            title={"Overview"}
            // onFilterChange={handlePeriodChange}
            // {...{
            //   setSelectedMonth,
            //   setSelectedYear,
            //   selectedMonth,
            //   selectedYear,
            // }}
          />

          <div
            className={styles.doughnut_container}
            style={{ padding: "1.5rem", marginTop: "2rem" }}
          >
            <p className={styles.card_subheading}>
              Total Stationary Combustion Emissions (tCO2e):{" "}
              {formatNumberCommaSeparated(
                fixedTons(stationaryEmission?.totalEmission ?? 0)
              )}
            </p>
            {stationaryEmissionLabels?.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  gap: "2rem",
                  alignItems: "flex-start",
                }}
              >
                <div className={styles.stationary_chart_container}>
                  <div className={styles.doughnut_table_div}>
                    {stationaryEmissionLabels.map((item, index) => (
                      <div key={index} className={styles.table_container}>
                        <div className={styles.table_row}>
                          <span
                            className={styles.table_row_label}
                            style={{
                              backgroundColor: item.color,
                            }}
                          ></span>
                          <span className={styles.table_text}>
                            {item.label}
                          </span>
                        </div>
                        <span className={styles.table_text}>
                          {formatNumberCommaSeparated(
                            fixedTons(item?.value ?? 0)
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                  <Box sx={{ width: "60%", ml: 2 }}>
                    <EchartDoughnutChart
                      labels={stationaryEmissionLabels?.map((el) => el?.label)}
                      dataPoints={stationaryEmissionLabels?.map((el) =>
                        Number(el?.value)
                      )}
                      colors={stationaryEmissionLabels?.map((el) => el?.color)}
                      legendPosition="top"
                      customWidth={"100%"}
                      customHeight={"80%"}
                      hide={true}
                    />
                  </Box>

                  <div
                    style={{
                      width: "300px",
                      height: "250px",
                      padding: "16px",
                      background: "#fafafa",
                      borderRadius: "8px",
                      flexShrink: 0, // optional: prevents chart from shrinking
                    }}
                  >
                    <Bar data={data} options={options} />
                  </div>
                </div>
              </div>
            ) : (
              <Box sx={{ height: "80%" }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    alignItems: "center",
                    fontFamily: "inter",
                    my: "8rem",
                    fontSize: "24px",
                  }}
                >
                  No Data Found
                </Typography>
              </Box>
            )}
          </div>


          <div
      style={{
        background: "#fff",
        borderRadius: "8px",
        padding: "1.5rem",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        marginTop: "2rem"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <p
          style={{
            fontWeight: 500,
            fontSize: "14px",
            color: "#555",
            margin: 0,
          }}
        >
          Vintage Year Distribution
        </p>
        <select style={{ padding: "6px 12px", borderRadius: "4px" }}>
          <option>Filter</option>
        </select>
      </div>

      <div style={{ height: "300px" }}>
        <Bar data={data1} options={options1} />
      </div>
    </div>
        </div>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Dashboard;
